export const WORKFLOW_CATEGORY = {
  ASSET: "asset",
  LEAD: "lead",
  DEAL: "deal",
  TASK: "task",
  ATTENDANCE: "attendance",
  CALENDAR: "calendar",
  EMPLOYEE_REPORTING: "employee_reporting",
  TICKET: "ticket",
  GENERAL: "general",
} as const;

export const WORKFLOW_TRIGGER_TYPE = {
  EVENT: "event",
  SCHEDULE: "schedule",
  MANUAL: "manual",
  RECURRING: "recurring",
} as const;

export const WORKFLOW_ERROR_STRATEGY = {
  HALT: "halt",
  CONTINUE: "continue",
  NOTIFY: "notify",
} as const;

export const WORKFLOW_LOG_LEVEL = {
  DEBUG: "debug",
  INFO: "info",
  WARN: "warn",
  ERROR: "error",
} as const;

export const WORKFLOW_STATUS = {
  PENDING: "pending",
  RUNNING: "running",
  COMPLETED: "completed",
  FAILED: "failed",
  SKIPPED: "skipped",
  TIMEOUT: "timeout",
  CANCELLED: "cancelled",
} as const;

export const WORKFLOW_SCHEDULE_TYPE = {
  CRON: "cron",
  INTERVAL: "interval",
  DAILY: "daily",
  WEEKLY: "weekly",
  MONTHLY: "monthly",
} as const;

// Type exports
export type WorkflowCategory =
  | (typeof WORKFLOW_CATEGORY)[keyof typeof WORKFLOW_CATEGORY]
  | any;
export type WorkflowTriggerType =
  (typeof WORKFLOW_TRIGGER_TYPE)[keyof typeof WORKFLOW_TRIGGER_TYPE];
export type WorkflowErrorStrategy =
  (typeof WORKFLOW_ERROR_STRATEGY)[keyof typeof WORKFLOW_ERROR_STRATEGY];
export type WorkflowLogLevel =
  (typeof WORKFLOW_LOG_LEVEL)[keyof typeof WORKFLOW_LOG_LEVEL];
export type WorkflowStatus =
  (typeof WORKFLOW_STATUS)[keyof typeof WORKFLOW_STATUS];
export type WorkflowScheduleType =
  (typeof WORKFLOW_SCHEDULE_TYPE)[keyof typeof WORKFLOW_SCHEDULE_TYPE];

// Helper functions
export const getAllEnumValues = <T extends Record<string, string>>(
  enumObj: T
): string[] => {
  return Object.values(enumObj);
};

export const isValidEnumValue = <T extends Record<string, string>>(
  enumObj: T,
  value: string
): boolean => {
  return Object.values(enumObj).includes(value);
};
